export function parseTime(timeStr) {
  if (!timeStr) return null
  const [h, m] = timeStr.split(":").map(Number)
  const date = new Date()
  date.setHours(h, m, 0, 0)
  return date
}
